import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import './vimeo.html';
import './vimeo.scss';

components.preload('fancybox-video-iframe-new');

export interface WCCFancyboxVimeoVMConfig {
    id: SubscribableOrNullableValue<string>
}

@injectable()
export default class WCCFancyboxVimeoVM {
    src: Subscribable<string | undefined>
    thumbnail: Subscribable<string | undefined>

    isReady: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) config: WCCFancyboxVimeoVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        const id = ko.flattenComputed(config.id);

        this.src = id.pluck(id => `https://player.vimeo.com/video/${id}`);
        this.thumbnail = ko.fromPromise((id) => id != undefined ? this.getThumbnailURL(id) : undefined, [id]);

        this.isReady = ko.pureComputed(() => id() != undefined);

        ko.applyBindingsToNode(info.element, {
            'visible': this.isReady,

            'css': {
                'wcc-fancybox-vimeo': true
            }
        });
    }

    private async getThumbnailURL(id: string) {
        const apiUrl = `https://vimeo.com/api/oembed.json?url=https://vimeo.com/${id}`;
        const response = await $.get(apiUrl);

        return <string>response.thumbnail_url;
    }
}